document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling?.id) summary.setAttribute('aria-controls', summary.nextElementSibling.id);

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const details = event.target.closest('details[open]');
  if (!details) return;

  const summary = details.querySelector('summary');
  details.removeAttribute('open');
  summary.setAttribute('aria-expanded', false);
  summary.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function debounce(fn, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

window.Shopify ||= {};

Shopify.bind = (fn, scope) => function (...args) {
  return fn.apply(scope, args);
};

Shopify.setSelectorByValue = (selector, value) => {
  for (let index = 0; index < selector.options.length; index += 1) {
    const option = selector.options[index];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = index;
      return index;
    }
  }
};

Shopify.addListener = (target, eventName, callback) => target.addEventListener(eventName, callback, false);

Shopify.postLink = (path, options = {}) => {
  const form = document.createElement('form');
  form.method = options.method || 'post';
  form.action = path;

  Object.entries(options.parameters || {}).forEach(([name, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
};

Shopify.CountryProvinceSelector = function (countryId, provinceId, options) {
  this.countryEl = document.getElementById(countryId);
  this.provinceEl = document.getElementById(provinceId);
  this.provinceContainer = document.getElementById(options.hideElement || provinceId);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    Shopify.setSelectorByValue(this.countryEl, this.countryEl.dataset.default);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.dataset.default;
    if (value && this.provinceEl.options.length > 0) Shopify.setSelectorByValue(this.provinceEl, value);
  },

  countryHandler() {
    const option = this.countryEl.options[this.countryEl.selectedIndex];
    const provinces = JSON.parse(option.dataset.provinces);
    this.provinceEl.replaceChildren();

    if (provinces.length === 0) {
      this.provinceContainer.style.display = 'none';
      return;
    }

    provinces.forEach(([value, label]) => {
      const province = document.createElement('option');
      province.value = value;
      province.textContent = label;
      this.provinceEl.appendChild(province);
    });
    this.provinceContainer.style.display = '';
  },
};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', () => this.loadContent());
  }

  loadContent(focus = true) {
    pauseAllMedia();
    if (this.hasAttribute('loaded')) return;

    const media = this.querySelector('template').content.firstElementChild.cloneNode(true);
    this.setAttribute('loaded', true);
    this.appendChild(media);
    if (focus) media.focus();
    if (media.nodeName === 'VIDEO' && media.hasAttribute('autoplay')) media.play();

    const originalStyle = media.getAttribute('style');
    media.style.display = 'block';
    window.setTimeout(() => {
      if (originalStyle === null) media.removeAttribute('style');
      else media.setAttribute('style', originalStyle);
    }, 0);
  }
}

customElements.define('deferred-media', DeferredMedia);
